<template>
	<div class="">
		<div class="h3 ftw600">
			<!-- 我的課堂 -->
			{{$t('studentsCom.myClass')}}
		</div>
		<a-spin :spinning="loading">
			<div class="pos-re">
				<div class="pos-ab" style="right: 0;top: 0;">
					<!-- 預約新課堂 -->
					<!-- <button type="button" class="btn btn-theme br4 px-5" @click="toClass()">
						{{$t('studentsCom.bookNewClassroom')}}
					</button> -->
				</div>
				<a-tabs v-model:activeKey="activeKey" class="ftr-1-25">
					<a-tab-pane key="1" :tab="$t('studentsCom.list')">
						<div class="flex wid-fit border-gray bg-w p-1" style="border-radius: 30px;">
							<div class="text-center ftr-1 clickAct" @click="status = 1;updateList()"
								:class="status==1?'bg-theme cl-w':''"
								style="border-radius: 40px;width: 120px;line-height: 38px;">
								<!-- 概覽 -->
								{{$t('studentsCom.overview')}}
							</div>
							<div class="text-center ftr-1 clickAct" @click="status = 3;updateList()"
								:class="status==3?'bg-theme cl-w':''"
								style="border-radius: 40px;width: 120px;line-height: 38px;">
								<!-- 待上课 -->
								{{$t('studentsCom.waitingClass')}}
							</div>
							<div class="text-center ftr-1 clickAct" @click="status = 2;updateList()"
								:class="status==2?'bg-theme cl-w':''"
								style="border-radius: 40px;width: 120px;line-height: 38px;">
								<!-- 待確認完成 -->
								{{$t('studentsCom.confirmationCompletion')}}
							</div>
							<div class="text-center ftr-1 clickAct" @click="status = 4;updateList()"
								:class="status==4?'bg-theme cl-w':''"
								style="border-radius: 40px;width: 120px;line-height: 38px;">
								<!-- 已完成 -->
								{{$t('studentsCom.completed')}}
							</div>
						</div>
						<div class="flex alcenter space mt-3">
							<div class="flex alcenter">
								<div class="ft16">
									{{$t('studentsCom.sortBy')}}
								</div>
								<a-select style="width: 180px;margin-left: 10px;" placeholder="请选择" v-model="search.sort" @change="getList">
									<a-select-option value="">{{$t('studentsCom.selectPlaceholder')}}</a-select-option>
									<a-select-option value="createtime desc">{{$t('studentsCom.sortDescOrEsc1')}}</a-select-option>
									<a-select-option value="createtime asc">{{$t('studentsCom.sortDescOrEsc2')}}</a-select-option>
									<a-select-option value="updatetime desc">{{$t('studentsCom.sortDescOrEsc3')}}</a-select-option>
									<a-select-option value="updatetime asc">{{$t('studentsCom.sortDescOrEsc4')}}</a-select-option>
								</a-select>
							</div>
							<div class="flex alcenter">
								<a-input :placeholder="$t('studentsCom.searchOrderID')" style="width: 200px" v-model="search.keyWord"></a-input>
								<a-range-picker  valueFormat="YYYY-MM-DD" style="width: 300px;margin-left: 10px;" v-model="search.time" />
								<div class="btn btn-theme ms-3" @click="getList">
									{{$t('appointment.confirm')}}
								</div>
							</div>
							
						</div>

						<div v-if="status==1">
							<div class="mt-4 ftr-1">
								{{$t('studentsCom.all')}}
							</div>
							<!--  -->
							<div v-for="(item,index) in orderList">
								<div class="mt-2 border-gray bg-w ftr-1 py-2 px-3 flex alcenter justify-content-between"
									style="border-left: 3px solid #52C4C9 !important;">
									<div class="flex flex-wrap alcenter">
										<div class=" flex alcenter">
											<img :src="item.photo_image" alt="" class="photo-40" style="border-radius: 2px;" />
											<div class="ml10">
												<div class="ftw600 cl-black">
													{{item.name}}
												</div>
												<div>
													{{$t('common.classID')}}:{{item.id}}
												</div>
											</div>
											
										</div>
										<div class="ms-3 border-l-gray ps-3 cl-placeholder">
											<div>{{item.course_name}}</div>
											<div>{{$t('common.formalClass')}} <span class="cl-black ms-3"> {{$t('appointment.contactTool')}}{{item.contact_way_text}}</span> </div>
										</div>
										<div class="ms-3 border-l-gray ps-3" style="height: 46px;line-height: 46px;">
											{{item.split_start_time.year}}-{{item.split_start_time.month}}-{{item.split_start_time.day}}
											<span>({{changeNum(convertToTimeZone(item.start_time).date.week)}})</span>
											{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
											-
											{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
										</div>
										<div class="ms-3 border-l-gray ps-3" >
											<div style="width: 125px;">
												<span v-if="item.exception_status==2">{{$t('common.indispute')}}</span>
												<span v-else-if="item.status==3"> {{$t('common.courseCancelled')}}</span>
												<span v-else-if="item.status==2"> {{$t('studentsCom.completed')}}</span>
												<span v-else-if="item.confirmation_status==1&&item.status==1"> {{$t('studentsCom.waitingClass')}}</span>
												<span v-else-if="item.order_type==2&&item.confirmation_status==2">{{$t('common.iConfirm')}} </span>
												<span v-else-if="item.order_type==1&&item.confirmation_status==2">{{$t('common.teacherConfirm')}} </span>
											</div>
											<div class="flex" v-if="item.order_type==2&&item.confirmation_status==2&&item.status!=3&&item.status!=2">
												<img src="../../../assets/image/staduents/class-no.png" alt="" 
												@click="cancelOrder(item.id)" style="width: 20px;height: 20px;" />
												<img src="../../../assets/image/staduents/class-completed.png"
												 @click="confirmationOrder(item.id)" alt="" class="ml10" style="width: 20px;height: 20px;" />
											</div>
										</div>
										<div class="ms-3 border-l-gray ps-3 flex">
											<img src="../../../assets/image/staduents/class-work.png" alt="" class="mr5" @click="toReservation(item.id)"
											 :title="$t('teacherConfirms.homework')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-test.png" alt="" class="mr5" @click="toReservation(item.id)"
											:title="$t('teacherConfirms.test')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-rate.png" alt="" @click="openKefu(item.teacher_info.user_id)"
											 :title="$t('studentsCom.rating')" class="mr5" style="width: 30px;height: 30px;" />
										</div>
										
										<!-- <div class="text-center ml20">
											<div class="ftr-1 cl-price">
												{{convertToTimeZone(item.start_time).date.month}}月
											</div>
											<div class="ft14">
												{{convertToTimeZone(item.start_time).date.day}}
											</div>
										</div>
										<div class="ml20 ">
											{{changeNum(convertToTimeZone(item.start_time).date.week)}}，
											{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
											-
											{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
										</div> -->
										
										<!-- <div class="ml15">
											{{item.course_name}}
										</div> -->
									</div>
									<button type="button" class="btn btn-theme br4 px-5"
										@click="toReservation(item.id)">{{$t('studentsCom.enterClassroom')}}</button>
									<div style="width: 50px;" @click="cancelOrder(item.id)" v-if="item.status==1&&timeCompare12(item.start_time)">
										<img src="../../../assets/image/staduents/class-cancle.png" alt="" style="width: 30px;height: 30px;" />
									</div>
									<div v-else style="width: 50px;"></div>
								</div>
							</div>
							
						</div>

						<div v-if="status==3">
							<div class="mt-4 ftr-1">
								{{$t('studentsCom.waitingClass')}} 
							</div>
							<div v-for="(item,index) in orderList">
								<div class="mt-2 border-gray bg-w ftr-1 py-2 px-3 flex alcenter justify-content-between"
									style="border-left: 3px solid #52C4C9 !important;"
									v-if="item.status==1">
									<div class="flex flex-wrap alcenter">
										<div class=" flex alcenter">
											<img :src="item.photo_image" alt="" class="photo-40" style="border-radius: 2px;" />
											<div class="ml10">
												<div class="ftw600 cl-black">
													{{item.name}}
												</div>
												<div>
													{{$t('common.classID')}}:{{item.id}}
												</div>
											</div>
											
										</div>
										<div class="ms-3 border-l-gray ps-3 cl-placeholder">
											<div>{{item.course_name}}</div>
											<div>{{$t('common.formalClass')}} <span class="cl-black ms-3"> {{$t('appointment.contactTool')}}{{item.contact_way_text}}</span> </div>
										</div>
										<div class="ms-3 border-l-gray ps-3" style="height: 46px;line-height: 46px;">
											{{item.split_start_time.year}}-{{item.split_start_time.month}}-{{item.split_start_time.day}}
											<span>({{changeNum(convertToTimeZone(item.start_time).date.week)}})</span>
											{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
											-
											{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
										</div>
										<div class="ms-3 border-l-gray ps-3" >
											<div style="width: 125px;">
												<span v-if="item.exception_status==2">{{$t('common.indispute')}}</span>
												<span v-else-if="item.status==3"> {{$t('common.courseCancelled')}}</span>
												<span v-else-if="item.status==2"> {{$t('studentsCom.completed')}}</span>
												<span v-else-if="item.confirmation_status==1&&item.status==1"> {{$t('studentsCom.waitingClass')}}</span>
												<span v-else-if="item.order_type==2&&item.confirmation_status==2">{{$t('common.iConfirm')}} </span>
												<span v-else-if="item.order_type==1&&item.confirmation_status==2">{{$t('common.teacherConfirm')}} </span>
											</div>
											<div class="flex" v-if="item.order_type==2&&item.confirmation_status==2&&item.status!=3&&item.status!=2">
												<img src="../../../assets/image/staduents/class-no.png" alt="" style="width: 20px;height: 20px;" />
												<img src="../../../assets/image/staduents/class-completed.png" alt="" class="ml10" style="width: 20px;height: 20px;" />
											</div>
										</div>
										<div class="ms-3 border-l-gray ps-3 flex">
											<img src="../../../assets/image/staduents/class-note.png"
											 :title="$t('teacherConfirms.notes')" alt="" class="mr5" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-work.png" alt="" class="mr5" 
											 :title="$t('teacherConfirms.homework')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-test.png" alt="" class="mr5" 
											:title="$t('teacherConfirms.test')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-rate.png" alt="" @click="openKefu(item.teacher_info.user_id)"
											 :title="$t('studentsCom.rating')" class="mr5" style="width: 30px;height: 30px;" />
										</div>
									</div>
									<button type="button" class="btn btn-theme br4 px-5"
										@click="toReservation(item.id)">{{$t('studentsCom.enterClassroom')}}</button>
									<div style="width: 50px;" @click="cancelOrder(item.id)" v-if="item.status==1&&timeCompare12(item.start_time)">
										<img src="../../../assets/image/staduents/class-cancle.png" alt="" style="width: 30px;height: 30px;" />
									</div>
									<div v-else style="width: 50px;"></div>
								</div>
							</div>
							
						</div>
						<div v-if="status==2">
							<div class="mt-4 ftr-1">
								{{$t('studentsCom.confirmationCompletion')}} 
							</div>
							<div v-for="(item,index) in orderList">
								<div class="mt-2 border-gray bg-w ftr-1 py-2 px-3 flex alcenter justify-content-between"
									style="border-left: 3px solid #52C4C9 !important;"
									v-if="item.status==1&&item.confirmation_status==1">
									<div class="flex flex-wrap alcenter">
										<div class=" flex alcenter">
											<img :src="item.photo_image" alt="" class="photo-40" style="border-radius: 2px;" />
											<div class="ml10">
												<div class="ftw600 cl-black">
													{{item.name}}
												</div>
												<div>
													{{$t('common.classID')}}:{{item.id}}
												</div>
											</div>
											
										</div>
										<div class="ms-3 border-l-gray ps-3 cl-placeholder">
											<div>{{item.course_name}}</div>
											<div>{{$t('common.formalClass')}} <span class="cl-black ms-3"> {{$t('appointment.contactTool')}}{{item.contact_way_text}}</span> </div>
										</div>
										<div class="ms-3 border-l-gray ps-3" style="height: 46px;line-height: 46px;">
											{{item.split_start_time.year}}-{{item.split_start_time.month}}-{{item.split_start_time.day}}
											<span>({{changeNum(convertToTimeZone(item.start_time).date.week)}})</span>
											{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
											-
											{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
										</div>
										<div class="ms-3 border-l-gray ps-3" >
											<div style="width: 125px;">
												<span v-if="item.exception_status==2">{{$t('common.indispute')}}</span>
												<span v-else-if="item.status==3"> {{$t('common.courseCancelled')}}</span>
												<span v-else-if="item.status==2"> {{$t('studentsCom.completed')}}</span>
												<span v-else-if="item.confirmation_status==1&&item.status==1"> {{$t('studentsCom.waitingClass')}}</span>
												<span v-else-if="item.order_type==2&&item.confirmation_status==2">{{$t('common.iConfirm')}} </span>
												<span v-else-if="item.order_type==1&&item.confirmation_status==2">{{$t('common.teacherConfirm')}} </span>
											</div>
											<div class="flex" v-if="item.order_type==2&&item.confirmation_status==2&&item.status!=3&&item.status!=2">
												<img src="../../../assets/image/staduents/class-no.png" alt="" style="width: 20px;height: 20px;" />
												<img src="../../../assets/image/staduents/class-completed.png" alt="" class="ml10" style="width: 20px;height: 20px;" />
											</div>
										</div>
										<div class="ms-3 border-l-gray ps-3 flex">
											<img src="../../../assets/image/staduents/class-note.png"
											 :title="$t('teacherConfirms.notes')" alt="" class="mr5" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-work.png" alt="" class="mr5" 
											 :title="$t('teacherConfirms.homework')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-test.png" alt="" class="mr5" 
											:title="$t('teacherConfirms.test')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-rate.png" alt="" @click="openKefu(item.teacher_info.user_id)"
											 :title="$t('studentsCom.rating')" class="mr5" style="width: 30px;height: 30px;" />
										</div>
									</div>
									<button type="button" class="btn btn-theme br4 px-5"
										@click="toReservation(item.id)">{{$t('studentsCom.enterClassroom')}}</button>
									<div style="width: 50px;" @click="cancelOrder(item.id)" v-if="item.status==1&&timeCompare12(item.start_time)">
										<img src="../../../assets/image/staduents/class-cancle.png" alt="" style="width: 30px;height: 30px;" />
									</div>
									<div v-else style="width: 50px;"></div>
								</div>
							</div>
							
						</div>
						<div v-if="status==4">
							<div class="mt-4 ftr-1">
								{{$t('studentsCom.completed')}} 
							</div>
							<div v-for="(item,index) in orderList">
								<div class="mt-2 border-gray bg-w ftr-1 py-2 px-3 flex alcenter justify-content-between"
									style="border-left: 3px solid #52C4C9 !important;"
									v-if="item.status==2">
									<div class="flex flex-wrap alcenter">
										<div class=" flex alcenter">
											<img :src="item.photo_image" alt="" class="photo-40" style="border-radius: 2px;" />
											<div class="ml10">
												<div class="ftw600 cl-black">
													{{item.name}}
												</div>
												<div>
													{{$t('common.classID')}}:{{item.id}}
												</div>
											</div>
											
										</div>
										<div class="ms-3 border-l-gray ps-3 cl-placeholder">
											<div>{{item.course_name}}</div>
											<div>{{$t('common.formalClass')}} <span class="cl-black ms-3"> {{$t('appointment.contactTool')}}{{item.contact_way_text}}</span> </div>
										</div>
										<div class="ms-3 border-l-gray ps-3" style="height: 46px;line-height: 46px;">
											{{item.split_start_time.year}}-{{item.split_start_time.month}}-{{item.split_start_time.day}}
											<span>({{changeNum(convertToTimeZone(item.start_time).date.week)}})</span>
											{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
											-
											{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
										</div>
										<div class="ms-3 border-l-gray ps-3" >
											<div style="width: 125px;">
												<span v-if="item.exception_status==2">{{$t('common.indispute')}}</span>
												<span v-else-if="item.status==3"> {{$t('common.courseCancelled')}}</span>
												<span v-else-if="item.status==2"> {{$t('studentsCom.completed')}}</span>
												<span v-else-if="item.confirmation_status==1&&item.status==1"> {{$t('studentsCom.waitingClass')}}</span>
												<span v-else-if="item.order_type==2&&item.confirmation_status==2">{{$t('common.iConfirm')}} </span>
												<span v-else-if="item.order_type==1&&item.confirmation_status==2">{{$t('common.teacherConfirm')}} </span>
											</div>
											<div class="flex" v-if="item.order_type==2&&item.confirmation_status==2&&item.status!=3&&item.status!=2">
												<img src="../../../assets/image/staduents/class-no.png" alt="" @click="cancelOrder(item.id)" style="width: 20px;height: 20px;" />
												<img src="../../../assets/image/staduents/class-completed.png" 
												alt="" class="ml10" style="width: 20px;height: 20px;" />
											</div>
										</div>
										<div class="ms-3 border-l-gray ps-3 flex">
											<img src="../../../assets/image/staduents/class-note.png"
											 :title="$t('teacherConfirms.notes')" alt="" class="mr5" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-work.png" alt="" class="mr5" 
											 :title="$t('teacherConfirms.homework')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-test.png" alt="" class="mr5" 
											:title="$t('teacherConfirms.test')" style="width: 30px;height: 30px;" />
											<img src="../../../assets/image/staduents/class-rate.png" alt="" @click="openKefu(item.teacher_info.user_id)"
											 :title="$t('studentsCom.rating')" class="mr5" style="width: 30px;height: 30px;" />
										</div>
									</div>
									<button type="button" class="btn btn-theme br4 px-5"
										@click="toReservation(item.id)">{{$t('studentsCom.enterClassroom')}}</button>
									<div style="width: 50px;" @click="cancelOrder(item.id)" v-if="item.status==1&&timeCompare12(item.start_time)">
										<img src="../../../assets/image/staduents/class-cancle.png" alt="" style="width: 30px;height: 30px;" />
									</div>
									<div v-else style="width: 50px;"></div>
								</div>
							</div>
							
						</div>
						<!-- <div class="flex justify-content-center mt-4">
							<a-pagination v-model:current="page" :total="totalCount" show-less-items />
						</div> -->
					</a-tab-pane>
					<a-tab-pane key="2" :tab="$t('studentsCom.calendar')">
						<div class="bg-w p-2" v-if="activeKey=='2'">
							<calendar></calendar>
						</div>

					</a-tab-pane>
				</a-tabs>
			</div>
		</a-spin>
	</div>
</template>

<script>
	import calendar from './calendar.vue'
	export default {
		components: {
			calendar
		},
		data() {
			return {
				activeKey: '1',
				status: 1,
				orderList: [],
				page: 1,
				totalCount: 0,
				loading: false,
				search:{
					time:[],
					keyWord:'',
					sort:''
				}
			}
		},
		created() {
			this.getList()
		},
		methods: {
			timeCompare12(str){
				// 给定的目标时间
				let targetTime = new Date(str);
				
				// 获取当前时间
				let currentTime = new Date();
				
				// 计算当前时间和目标时间的时间差（单位为毫秒）
				let timeDifference = targetTime - currentTime;
				
				// 判断目标时间是否在当前时间的24小时内（24小时 = 24 * 60 * 60 * 1000 毫秒）
				let isWithin24Hours = timeDifference >= 0 && timeDifference <= 12 * 60 * 60 * 1000;
				
				console.log(isWithin24Hours);
				// isWithin24Hours 将是 true 或 false，指示目标时间是否在当前时间的24小时内
				return isWithin24Hours
			},
			confirmationOrder(id) {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmAppointment'),
					content: this.$t('teacherConfirms.confirmAppointmentText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/confirmationOrder', {
							order_id: id
						}).then(res => {
							this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1, () => {
								this.getList()
							});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
				
			},
			cancelOrder(id) {
				this.$confirm({
					title: this.$t('teacherConfirms.confirmCancel'),
					content: this.$t('teacherConfirms.cancelClassText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('reservation/cancelOrder', {
							order_id: id
						}).then(res => {
							this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1,
								() => {
									this.getList()
								});
						});
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			toReservation(ID) {
				this.$router.push('/teacherConfirms?id=' + ID)
			},
			toClass() {
				this.$emit('select', 0)
			},
			updateList() {
				this.page = 1
				this.getList()
			},
			getList() {
				this.loading = true
				let num = 0 ,confirmation_status = 0
				if(this.status==1){
					num = 0
				}else if(this.status==2){
					num = 1
					confirmation_status = 1
				}else if(this.status==3){
					num = 1
				}else{
					num = 2
				}
				this.$http.api('reservation/orderList', {
					page: this.page,
					limit: 100,
					status: num,
					confirmation_status:confirmation_status,
					start_time:this.search.time.length!=0? this.search.time[0]+' 00:00:00' : '',
					finish_time:this.search.time.length!=0? this.search.time[1]+' 23:59:59' : '',
					order_sn:this.search.keyWord,
					order:this.search.sort
				}).then(res => {
					this.loading = false
					this.orderList = res.list
					this.totalCount = res.count
				})
			}
		}

	}
</script>

<style>
	.ant-tabs-nav .ant-tabs-tab {
		font-size: 16px;
	}

	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #52C4C9;
	}

	.ant-tabs-nav .ant-tabs-tab-active {
		color: #52C4C9;
		text-shadow: 0 0 0.25px #52C4C9
	}

	.ant-tabs-ink-bar {
		background-color: #52C4C9;
	}
</style>